// dependencies
import Fuse from "fuse.js";

// constants
import FUSE_OPTIONS from "../constants/FuzzySearchOptions";

const baseAction = "HASHTAGS";

export function GetAll() {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:GETALL` });
	};
}

export function ParseHashtags(hashtagList) {
	return (dispatch) => {
		// fuse the hashtags
		const fuse = new Fuse(
			hashtagList.map((word) => ({ name: word })),
			FUSE_OPTIONS
		);

		// send to reducer
		dispatch({ type: `${baseAction}:PARSEHASHTAGS`, all: fuse });
	};
}
